<template>
    <div>
        <el-dialog title="资产明细" fullscreen :visible.sync="assetDetailDialogVisible" @open="openDialog"
                   @close="closeDialog" :close-on-click-modal="false">
            <el-input v-model="queryParams.userId" placeholder="搜索用户ID"
                      style="width: 500px"></el-input>
            <el-select v-model="queryParams.type" placeholder="请选择" @change="changeType">
                <el-option :value="0" label="存入资产"></el-option>
                <el-option :value="1" label="解锁资产"></el-option>
            </el-select>
            <el-button type="primary" @click="openDialog" style="margin: 20px 0">搜 索</el-button>

            <div v-if="queryParams.type==0">
                <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="dataList" :row-key="() => Math.random()">
                    <el-table-column prop="userId" fixed="left" label="用户ID"></el-table-column>
                    <el-table-column prop="amount" label="存入数量"></el-table-column>
                    <el-table-column label="存入时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime | moment}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-if="queryParams.type==1">
                <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="dataList" :row-key="() => Math.random()">
                    <el-table-column prop="userId" fixed="left" label="用户ID"></el-table-column>
                    <el-table-column prop="amount" label="解锁资产"></el-table-column>
                    <el-table-column prop="unlockeCycle" label="解锁周期"></el-table-column>
                    <el-table-column label="解锁状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.unlockStatus==0">解锁中</span>
                            <span v-if="scope.row.unlockStatus==1">完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="提交解锁时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.unlockTime | moment}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="解锁到账时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.paymentTime | moment}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import {mapMutations, mapState, mapGetters} from 'vuex';

    export default {
        name: "assetDetail",
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {poolId: "", type: 0, userId: "", page: 1, size: 10},
            }
        },
        computed: {
            ...mapState("NewCoin", ["assetDetailDialogVisible"])
        },
        methods: {
            ...mapMutations("NewCoin", ["setAssetDetailDialogVisible", "setPoolId"]),
            ...mapGetters("NewCoin", ["getPoolId"]),
            openDialog() {
                this.queryParams.poolId = this.getPoolId();
                api.userRecordPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            closeDialog() {
                this.setAssetDetailDialogVisible(false);
                this.setPoolId(-1);
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.openDialog();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.openDialog();
            },
            changeType() {
                this.dataList = [];
                this.total = 0;
            }
        }
    }
</script>

<style scoped>

</style>